import { FC, memo } from 'react'
import { Box } from '@chakra-ui/react'
import { createIcon } from '@chakra-ui/icons'

import { CustomIconProps } from 'types'
import CustomIcon from '../../CustomIcon'

const UsersCheckmarkOutline = createIcon({
  displayName: 'UsersCheckmarkOutline',
  viewBox: '0 0 24 24',
  path: (
    <>
      <path
        d="M11,21H7.5A4.5,4.5,0,0,1,3,16.5v-9A4.5,4.5,0,0,1,7.5,3h9A4.5,4.5,0,0,1,21,7.5V11"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <circle
        cx="18"
        cy="18.00001"
        r="4"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <polyline
        points="16.75 17.887 17.75 18.887 19.25 17.387"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <circle
        cx="10.5"
        cy="9.50001"
        r="2"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <path d="M10.5,7.5a2,2,0,0,1,0,4" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" />
      <path d="M15,7.5a2,2,0,0,1,0,4" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" />
      <path d="M15,7.5a2,2,0,0,1,0,4" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" />
      <path d="M12,14H9a2,2,0,0,0-2,2" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" />
      <rect y="0.00001" width="24" height="24" fill="none" />
    </>
  ),
})

const UsersCheckmarkTwoTone = createIcon({
  displayName: 'UsersCheckmarkTwoTone',
  viewBox: '0 0 24 24',
  path: (
    <>
      <Box
        as="path"
        d="M11,21H7.5A4.5,4.5,0,0,1,3,16.5v-9A4.5,4.5,0,0,1,7.5,3h9A4.5,4.5,0,0,1,21,7.5V11"
        fill="none"
        stroke="twoToneStrokeColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <Box
        as="circle"
        cx="18"
        cy="18.00001"
        r="4"
        fill="twoToneLightColor"
        stroke="twoToneStrokeColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <Box
        as="polyline"
        points="16.75 17.887 17.75 18.887 19.25 17.387"
        fill="none"
        stroke="twoToneStrokeColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <Box
        as="circle"
        cx="10.5"
        cy="9.50001"
        r="2"
        fill="twoToneLightColor"
        stroke="twoToneStrokeColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <Box
        as="path"
        d="M10.5,7.5a2,2,0,0,1,0,4"
        fill="twoToneLightColor"
        stroke="twoToneStrokeColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <Box
        as="path"
        d="M15,7.5a2,2,0,0,1,0,4"
        fill="none"
        stroke="twoToneStrokeColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <Box
        as="path"
        d="M15,7.5a2,2,0,0,1,0,4"
        fill="none"
        stroke="twoToneStrokeColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <Box
        as="path"
        d="M12,14H9a2,2,0,0,0-2,2"
        fill="none"
        stroke="twoToneStrokeColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <rect y="0.00001" width="24" height="24" fill="none" />
    </>
  ),
})

const UsersCheckmark: FC<CustomIconProps> = (props) => {
  if (props.variant === 'twoTone') return <CustomIcon as={UsersCheckmarkTwoTone} {...props} />

  return <CustomIcon as={UsersCheckmarkOutline} {...props} />
}

export default memo(UsersCheckmark)
